import PortalIdParser from 'PortalIdParser';
import { getScopes } from 'quartz-auth/app/service';
import { BILLING_WRITE, CRM_ACCESS, CONTACTS_READ } from 'pricing-pages-lib/constants/Scopes';
export const isDevPortalSelector = () => {
  if (!PortalIdParser.get()) return false;
  const scopes = getScopes();
  const doesntHaveCRMAccess = !scopes.has(CRM_ACCESS) || !scopes.has(CONTACTS_READ);
  const isBillingAdmin = scopes.has(BILLING_WRITE);
  return doesntHaveCRMAccess && !isBillingAdmin;
};